import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import ContratoService from '../../../../../services/contrato-auth';
import { Link, useParams } from 'react-router-dom';



const FormSituacao = () => {
    const [situacao, setSituacao] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchContrato(id) {
        const response = await ContratoService.contratoEdit(id);
        setSituacao(response.data["situacao"]);
    }


    useEffect(() => {
        fetchContrato(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const contrato = await ContratoService.editar(id, {
                situacao: situacao
            })
            if (contrato.data["cod_contrato"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado na edição!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={3}>
                                <Col lg={6}>
                                    <Form.Group className="mb-3" controlId="Situação">
                                        <FloatingLabel
                                            label="Situação"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="Situação"
                                                name="situacao"
                                                onChange={e => setSituacao(e.target.value)}
                                            >
                                                <option value={situacao}>{situacao}</option>
                                                <option value="Ativo">Ativo</option>
                                                <option value="Concluído">Concluído</option>
                                                <option value="Cancelado">Cancelado</option>
                                                <option value="Rescindido">Rescindido</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={`/restrito/contratos/listar`}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Contrato atualizado com sucesso!</Alert>
                <Link to={`/restrito/contratos/listar`}>
                    <Button variant="primary" type="button">
                        Ir para Listagens Contratos
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default FormSituacao;